import React, { useEffect } from 'react';
import { Tag, BookOpen } from 'lucide-react';

const Blog = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const blogPosts = [
    {
      id: 1,
      title: 'Early Intervention: Key to Successful Child Development',
      content: 'Early intervention focuses on identifying developmental needs at an early age. It supports growth in communication, learning, and daily life skills. Timely therapy helps reduce future challenges for children. Research consistently shows that the earlier a child receives support, the better their long-term outcomes. By addressing delays sooner, we can help build the neural connections that are crucial for learning and behavior.',
      category: 'Child Development',
      author: 'Dr. Sarah Smith'
    },
    {
      id: 2,
      title: 'Creating a Sensory-Friendly Environment at Home',
      content: 'A sensory-friendly home helps children feel calm and secure. Small changes like lighting and noise control reduce stress. Organized spaces improve focus and emotional regulation. Consider creating "quiet corners" with soft textures and dimmable lights where your child can retreat when feeling overwhelmed. Visual schedules and clear routines also provide a sense of predictability and safety.',
      category: 'Parent Resources',
      author: 'Emily Johnson, OT'
    },
    {
      id: 3,
      title: 'Supporting Children with Special Needs',
      content: 'Every child has unique strengths and challenges. Individualized support helps children reach their full potential. Therapies focus on communication, behavior, and learning skills. It is important to celebrate small victories and progress. Collaboration between parents, therapists, and educators creates a holistic support system that empowers the child to thrive in all environments.',
      category: 'Child Care',
      author: 'Michael Brown'
    }
  ];

  return (
    <div className="font-sans text-[#424242] bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="bg-indigo-700 py-20 px-5 text-center text-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-indigo-900/50 to-violet-900/50"></div>
        <div className="absolute -bottom-10 -left-10 text-white/5 -rotate-12">
          <BookOpen size={300} strokeWidth={1} />
        </div>
        <div className="relative z-10 max-w-[800px] mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-4 ">Blog & Insights</h1>
          <p className="text-xl text-indigo-100 font-light">
            Stay informed with our latest articles on therapy techniques, child development, and rehabilitation.
          </p>
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto px-5 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-[20px] shadow-[0_10px_30px_rgba(0,0,0,0.05)] hover:shadow-[0_20px_40px_rgba(79,70,229,0.15)] transition-all duration-300 border border-gray-100 flex flex-col overflow-hidden group hover:-translate-y-2">
              <div className="p-8 flex flex-col h-full">
                <div className="mb-6 flex justify-between items-start">
                  <span className="inline-flex items-center gap-1.5 bg-indigo-50 text-indigo-700 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
                    <Tag size={12} />
                    {post.category}
                  </span>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-4 leading-tight group-hover:text-indigo-700 transition-colors">
                  {post.title}
                </h2>

                <p className="text-gray-500 mb-6 flex-1 leading-relaxed">
                  {post.content}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;

